export default "__VITE_ASSET__DCs0cozK__ 400w, __VITE_ASSET__BgclTX8j__ 800w, __VITE_ASSET__DyDF57Sm__ 1024w";